<template>
	<div>
		<p class="m-0 ds-text-base font-normal text-gray-900">{{staff.firstName}} {{staff.lastName}}</p>
		<p
			class="m-0 ds-text-base font-normal text-gray-900"
			v-if="staff.phoneNumber"
		>C: {{formatPhoneNumber(staff.phoneNumber)}}</p>
		<p class="m-0 ds-text-base font-normal text-gray-900 break-all" v-if="staff.emailAddress">
			E:
			<span class="lowercase">{{staff.emailAddress}}</span>
		</p>
		<a :href="`/messages/compose?coach=${staff.id}`" v-if="canMessage">
			<i class="sr-2 sr-v2-paper-airplane" />&nbsp;Send Message
		</a>
		<h4
			class="mt-1 mb-2 ds-text-xs font-semibold text-gray-500 uppercase"
		>{{position}}</h4>
	</div>
</template>

<script>
import AthleteField from "@/components/AthleteProfile//AthleteField";
import { SlideTransition } from '@sportsrecruits/playbook';
import AthleteJersey from "@/components/AthleteProfile//AthleteJersey";
import AthleteSectionSubheading from "@/components/AthleteProfile//AthleteSectionSubheading";
import formatPhoneNumber from "@/utils/formatters/phoneNumber";
import { mapGetters } from 'vuex';

export default {
	components: {
		AthleteField,
		SlideTransition,
		AthleteJersey,
		AthleteSectionSubheading
	},
	props: {
		affiliation: { type: Object, required: true }
	},
	methods: {
		formatPhoneNumber
	},
	computed: {
		...mapGetters('athleteProfile', [
			'isApplicableCollegeCoach',
		]),

		...mapGetters('userData', {
			myOrganizations: 'organizations',
		}),

        staff() {
            return this.affiliation.staff
        },
        
        position() {
            return this.affiliation.position
                || this.staff.position
                || 'Coach' 
        },

		isIntegrated() {
			return !!this.staff.id
		},

		canMessage() {
			return this.isIntegrated && (
				this.isApplicableCollegeCoach ||
				!!this.myOrganizations.find(org => org.id === this.staff.organization.id)
			)
		},
	}
}
</script>
